import type { FC } from "react";

import type { AnchorLinkProps } from "./AnchorLink.builder";

export const AnchorLink: FC<AnchorLinkProps> = ({ anchorId }) => {
  return <div id={anchorId} style={{ "scroll-margin-top": "100px" } as React.CSSProperties}></div>;
};
